import { useCallback, useState } from 'react';

import { useAuthActionsContext } from '~context/auth';
import {
	RegisterInbound,
	RegisterOutbound,
} from '~features/annals/enums/register';
import annalsGrid from '~features/annals/hooks/grid';
import { useSession } from '~hooks/useSession';
import { GTMAnalytics } from '~services/analytics';
import { gridApi } from '~services/api/grid';
import { userApi } from '~services/api/user';

export const useGridCardClick = () => {
	const { isDemoUser, userId } = useSession();

	const [shopBotClientId, setShopBotClientId] = useState<number>();

	const closeShop = useCallback(() => {
		setShopBotClientId(undefined);
	}, []);

	const { openRegister } = useAuthActionsContext();

	const { data: levelData } = userApi.useGetLevelQuery(
		{ userId },
		{ skip: isDemoUser || !userId }
	);

	const [triggerBotClicked] = gridApi.useBotClickedMutation();

	const userLevel = levelData?.level ?? 1;

	const sendCardClick = annalsGrid.useCardClick();

	const handleClick: React.MouseEventHandler = useCallback(
		(e) => {
			const clientId = Number(
				(e.currentTarget as HTMLAnchorElement).dataset['clientid']
			);
			const gridIndex = Number(
				(e.currentTarget as HTMLAnchorElement).dataset['gridindex']
			);
			const requiredLevel = Number(
				(e.currentTarget as HTMLAnchorElement).dataset['requiredlevel']
			);

			void sendCardClick({
				bot_UserId: clientId,
				index: gridIndex,
			});

			if (isDemoUser) {
				GTMAnalytics.characterChosen(clientId.toString());
			} else {
				void triggerBotClicked({
					userId,
					botId: clientId,
				});
			}

			if (requiredLevel > userLevel) {
				e.preventDefault();
				if (isDemoUser) {
					openRegister({
						cb: () => {
							setShopBotClientId(clientId);
						},
						analytics: {
							inbound: RegisterInbound.ChatClickLockedBot,
							outbound: RegisterOutbound.Chat,
							inboundParams: {
								botId: clientId.toString(),
							},
						},
					});
				} else {
					setShopBotClientId(clientId);
				}
			}
		},
		[
			isDemoUser,
			openRegister,
			sendCardClick,
			userLevel,
			triggerBotClicked,
			userId,
		]
	);

	return {
		handleClick,
		closeShop,
		shopBotClientId,
		userLevel,
	};
};
